module.exports = __webpack_public_path__ + "assets/img/ps-3-light.c54e414d.png";